export const validateExceptionDetail = (name, value) => {
  switch (name) {
    case "exceptionPieces":
      return value && value + "" ? null : "* Exception Pieces is required";
    case "exceptionDescription":
      return value && value + "" ? null : "* Exception Description is required";
    case "exceptionPackageType":
      return value && value + "" ? null : "* Package Type is required";
    default:
      return null;
  }
};

export const getDefaultExceptionDetail = () => {
  return {
    exceptionPieces: null,
    exceptionPackageType: null,
    exceptionDescription: null,
  };
};

export const getExceptionDetail = (editInfo) => {
  return {
    pieces: editInfo.exceptionPieces,
    packageType: editInfo.exceptionPackageType,
    description: editInfo.exceptionDescription,
  };
};

export const exceptionDetailFields = [
  "exceptionPieces",
  "exceptionPackageType",
  "exceptionDescription",
];
